import { Button, Picker, List } from "vant";

const components = {
  Button,
  Picker,
  List
};

export default {
  install(Vue) {
    Object.keys(components).forEach(key => {
      Vue.use(components[key]);
    });
  }
};
